import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getTariffModalOpen = (state: StateScheme) => {
    return state.selectTariff.IsTariffModalOpen
}
